export default __webpack_public_path__ + "static/media/photo--lg--88.2433ab70.jpg";